import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BaasicButton } from 'core/components';

function RelationshipChangeModalTemplate({ relationshipChangeModalStore}) {
    const {
        modalParams,
        takeMeToBrightree
    } = relationshipChangeModalStore;
    return (
        <section>
            <div className="modal__header">
                <h3 className='modal__header__title'>Relationship Change</h3>
            </div>
            <div className="modal__body">
                <p className='u-mar--bottom--med type--color--secondary'>You must go into Brightree to edit the contact information for the Insured Person.</p>
            </div>
            <div className='modal__footer'>
                <BaasicButton
                    className='btn btn--med btn--light'
                    label={"Take me to Brightree"}
                    onClick={() => takeMeToBrightree()}
                />
                 <BaasicButton
                    className='btn btn--med btn--primary'
                    label={"Acknowledge"}
                    onClick={() => modalParams.close()}
                />
            </div>
        </section>
    )
}
 
RelationshipChangeModalTemplate.propTypes = {
    relationshipChangeModalStore: PropTypes.object
};

export default defaultTemplate(RelationshipChangeModalTemplate);
